module.exports = __webpack_public_path__ + "img/bb.6c306587.svg";